// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bubble-display{transform:translateZ(0);width:100%;height:auto;filter:brightness(80%);-o-object-fit:cover;object-fit:cover}.bubble-display.round{border-radius:50%}.bubble-display.original{border-radius:10px}.bubble-display.square{border-radius:4px}.bubble-display.bubble-border{margin:0 6px}", ""]);
// Exports
module.exports = exports;
